import { render, staticRenderFns } from "./RelationQuest.vue?vue&type=template&id=330369e3&"
import script from "./RelationQuest.vue?vue&type=script&lang=js&"
export * from "./RelationQuest.vue?vue&type=script&lang=js&"
import style0 from "./RelationQuest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
